"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    r = (e = t) && "object" == typeof e && "default" in e ? e.default : e,
    n = require("react-feather"),
    o = require("@stitches/react"),
    a = require("polished"),
    i = o.createCss({
  prefix: "camara",
  theme: {
    colors: {
      brand_primary: "#088845",
      brand_secondary: "#E65F5C",
      brand_accent: "#DB7C00",
      brand_muted: "#C6DAF7",
      ui_primary: "#000000",
      ui_secondary: "#444444",
      ui_tertiary: "#E0E0E0",
      ui_border: "#DADCE0",
      ui_disabled: "#DEDEDE",
      ui_error: "#E22121",
      ui_warning: "#FF9A04",
      ui_success: "#28A745",
      ui_unknown: "#757575",
      bg_primary: "#FFFFFF",
      bg_secondary: "#F8F8F8",
      link_text: "#088845",
      link_secondary: "#707070",
      link_hover: a.lighten(.1, "#088845"),
      text_primary: "#000000",
      text_secondary: "#444444",
      text_tertiary: "#E0E0E0",
      text_placeholder: "#708090",
      text_disabled: "#9C9C9C",
      text_inverse: "#FFFFFF",
      text_error: "#E22121",
      text_success: "#28A745",
      button_text: "#FFFFFF",
      button_primary: "#088845",
      button_secondary: "#e7fef2",
      btn_sec_hover: a.darken(.05, "#e7fef2"),
      button_hover: "#01A14E",
      button_focus: a.darken(.1, "#01A14E"),
      button_pressed: "#017337",
      button_danger: "#E22121",
      button_dangerHover: a.darken(.1, "#FF4D4D"),
      button_dangerFocus: a.darken(.2, "#FF4D4D"),
      button_danger_sec_hover: a.lighten(.4, "#E22121"),
      primaryHighlight: a.darken(.1, "#088845"),
      primaryExtraHighlight: a.darken(.2, "#088845"),
      bgHighlight: a.darken(.1, "#FFFFFF"),
      bgHighlightHover: a.darken(.2, "#FFFFFF")
    },
    fonts: {
      body: 'Inter, -apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
      heading: '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
      mono: '-apple-system,system-ui,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,monospace'
    },
    fontSizes: {
      1: "0.625rem",
      2: "0.75rem",
      3: "0.875rem",
      4: "1rem",
      5: "1.125rem",
      6: "1.25rem",
      7: "1.5rem",
      8: "1.75rem",
      9: "2rem",
      10: "2.5rem",
      11: "3rem"
    },
    fontWeights: {
      regular: 400,
      medium: 500,
      bold: 700
    },
    lineHeights: {
      solid: 1,
      title: 1.25,
      copy: 1.5
    },
    letterSpacings: {
      default: "normal",
      tracked: "0.04em",
      overline: "1.5px"
    },
    space: {
      1: "4px",
      2: "8px",
      3: "16px",
      4: "24px",
      5: "32px",
      6: "64px",
      7: "128px"
    },
    sizes: {
      1: "4px",
      2: "8px",
      3: "16px",
      4: "32px",
      5: "64px",
      6: "128px"
    },
    radii: {
      1: "2px",
      2: "4px",
      3: "8px",
      4: "16px",
      round: "9999px"
    },
    borderWidths: {
      1: "1px"
    },
    borderStyles: {},
    shadows: {
      bg_shadow: "1px 2px 4px 2px #DADCE0"
    },
    zIndices: {},
    transitions: {}
  },
  media: {
    sm: "(min-width: 640px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 1024px)"
  },
  utils: {
    m: function m() {
      return function (e) {
        return {
          marginTop: e,
          marginBottom: e,
          marginLeft: e,
          marginRight: e
        };
      };
    },
    mt: function mt() {
      return function (e) {
        return {
          marginTop: e
        };
      };
    },
    mr: function mr() {
      return function (e) {
        return {
          marginRight: e
        };
      };
    },
    mb: function mb() {
      return function (e) {
        return {
          marginBottom: e
        };
      };
    },
    ml: function ml() {
      return function (e) {
        return {
          marginLeft: e
        };
      };
    },
    mx: function mx() {
      return function (e) {
        return {
          marginLeft: e,
          marginRight: e
        };
      };
    },
    my: function my() {
      return function (e) {
        return {
          marginTop: e,
          marginBottom: e
        };
      };
    },
    p: function p() {
      return function (e) {
        return {
          paddingTop: e,
          paddingBottom: e,
          paddingLeft: e,
          paddingRight: e
        };
      };
    },
    pt: function pt() {
      return function (e) {
        return {
          paddingTop: e
        };
      };
    },
    pr: function pr() {
      return function (e) {
        return {
          paddingRight: e
        };
      };
    },
    pb: function pb() {
      return function (e) {
        return {
          paddingBottom: e
        };
      };
    },
    pl: function pl() {
      return function (e) {
        return {
          paddingLeft: e
        };
      };
    },
    px: function px() {
      return function (e) {
        return {
          paddingLeft: e,
          paddingRight: e
        };
      };
    },
    py: function py() {
      return function (e) {
        return {
          paddingTop: e,
          paddingBottom: e
        };
      };
    },
    size: function size() {
      return function (e) {
        return {
          width: e,
          height: e
        };
      };
    },
    br: function br() {
      return function (e) {
        return {
          borderRadius: e
        };
      };
    },
    bg: function bg() {
      return function (e) {
        return {
          backgroundColor: e
        };
      };
    }
  }
}),
    l = i.styled,
    c = i.global,
    d = (0, i.theme)("dark-theme", {
  shadows: {
    bg_shadow: "1px 1.5px 3px #000"
  },
  colors: {
    brand_primary: "#37DAAA",
    brand_secondary: "#E65F5C",
    brand_accent: "#FDB447",
    brand_muted: "#B7CBEA",
    ui_primary: "#FFFFFF",
    ui_secondary: "#F5F5F5",
    ui_tertiary: "#555555",
    ui_border: "#444444",
    ui_disabled: "#242424",
    ui_error: "#E22121",
    ui_warning: "#FF9A04",
    ui_success: "#28A745",
    ui_unknown: "#757575",
    bg_primary: "#121212",
    bg_secondary: "#272727",
    link_text: "#37DAAA",
    link_secondary: "#DADCE0",
    link_hover: a.lighten(.1, "#37DAAA"),
    text_primary: "#FFFFFF",
    text_secondary: "#F5F5F5",
    text_tertiary: "#555555",
    text_placeholder: "#708090",
    text_disabled: "#525252",
    text_inverse: "#262626",
    text_error: "#FF4D4D",
    text_success: "#1CBD00",
    button_text: "#000000",
    button_primary: "#37DAAA",
    button_secondary: "hsla(149, 89%, 70%, 0.14)",
    btn_sec_hover: a.darken(.3, "hsla(149, 89%, 70%, 0.14)"),
    button_hover: "#28BE92",
    button_focus: a.lighten(.1, "#28BE92"),
    button_pressed: "#0CB181",
    button_danger: "#FF4D4D",
    button_dangerHover: a.lighten(.1, "#E22121"),
    button_dangerFocus: a.lighten(.1, "#FF4D4D"),
    button_danger_sec_hover: a.darken(.55, "#FF4D4D"),
    primaryHighlight: a.lighten(.1, "#37DAAA"),
    primaryExtraHighlight: a.lighten(.2, "#37DAAA"),
    bgHighlight: a.lighten(.1, "#111111"),
    bgHighlightHover: a.lighten(.2, "#111111")
  }
}),
    s = l("section", {
  border: "1px solid $ui_border",
  "& .accordion": {
    display: "flex",
    alignItems: "center",
    padding: "$2 $3",
    width: "100%",
    border: "none",
    backgroundColor: "transparent",
    color: "$text_primary",
    cursor: "pointer",
    outline: "none",
    transition: "background-color 0.6s ease"
  },
  "& .accordion-title": {
    fontSize: "$4",
    fontWeight: "$bold",
    display: "flex",
    alignItems: "center"
  },
  "& .accordion-title span": {
    marginRight: "$1"
  },
  "& .accordion-icon": {
    marginLeft: "auto",
    transition: "transform 0.4s ease"
  },
  "& .rotate": {
    transform: "rotate(90deg)"
  },
  "& .accordion:hover": {
    backgroundColor: "$bgHighlight"
  },
  "& .active": {
    backgroundColor: "transparent"
  },
  "& .accordion:active": {
    backgroundColor: ""
  },
  "& .accordion-content": {
    backgroundColor: "$bg_primary",
    overflow: "hidden",
    transition: "max-height 0.3s ease"
  },
  "& .accordion-text": {
    color: "$text_secondary",
    fontSize: "$2",
    lineHeight: "$copy",
    padding: "$3"
  }
}),
    u = l("a", {
  color: "$link_text !important",
  cursor: "pointer",
  textDecoration: "underline !important",
  "& > *": {
    color: "$link_text !important",
    "&:visited": {
      color: "$link_text !important"
    },
    "&:hover": {
      color: "$link_hover !important",
      textDecoration: "none !important"
    },
    "&:active": {
      color: "$link_hover !important"
    }
  },
  "&:visited": {
    color: "$link_text !important"
  },
  "&:hover": {
    color: "$link_hover !important",
    textDecoration: "none !important"
  },
  "&:active": {
    color: "$link_hover !important"
  },
  "& svg": {
    marginLeft: "$1"
  },
  variants: {
    variant: {
      primary: {},
      secondary: {
        color: "$link_secondary !important",
        textDecoration: "none !important",
        "&:hover": {
          color: "$link_hover !important",
          textDecoration: "underline !important"
        },
        "&:active": {
          color: "$link_hover !important"
        }
      }
    }
  },
  defaultVariants: {
    variant: "primary"
  }
}),
    m = function m(e) {
  var t = e.href,
      o = e.children,
      a = e.variant,
      i = e.underline;
  return e.external ? r.createElement(u, {
    href: t,
    target: "_blank",
    rel: "noopener noreferrer",
    variant: a,
    css: {
      textDecoration: !1 === i ? "none !important" : "underline"
    }
  }, o, r.createElement(n.ExternalLink, {
    size: 14,
    color: "#bbb"
  })) : r.createElement(u, {
    href: t,
    variant: a,
    css: {
      textDecoration: !1 === i ? "none !important" : "underline"
    }
  }, o);
};

m.defaultProps = {
  variant: "primary"
}, m.displayName = "Anchor";

var p = l("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  alignContent: "center",
  alignSelf: "center",
  verticalAlign: "middle",
  overflow: "hidden",
  textTransform: "uppercase",
  height: "40px",
  width: "40px",
  "& img": {
    width: "100%",
    height: "auto",
    display: "block"
  },
  variants: {
    size: {
      tiny: {
        height: "24px",
        width: "24px"
      },
      small: {
        height: "40px",
        width: "40px"
      },
      medium: {
        height: "64px",
        width: "64px"
      },
      large: {
        height: "80px",
        width: "80px"
      }
    },
    shape: {
      square: {
        borderRadius: "0"
      },
      circle: {
        borderRadius: "$round"
      }
    },
    stories: {
      true: {
        border: "5px solid $bg_primary",
        boxShadow: "0 0 0 2px orange"
      }
    }
  }
}),
    h = l("p", {
  textAlign: "center",
  fontWeight: "500"
}),
    g = l("div", {
  textAlign: "center",
  verticalAlign: "middle",
  p: "$2"
}),
    b = function b(e) {
  var t = e.initialsSize,
      n = e.imageSrc,
      o = e.imageAlt,
      a = e.icon,
      i = e.color,
      l = e.username;
  return r.createElement(p, {
    icon: a,
    size: e.size,
    shape: e.shape,
    stories: e.stories,
    css: {
      backgroundColor: e.bg || "$bg_secondary",
      objectFit: e.fit
    }
  }, a ? r.createElement(g, null, a) : n ? r.createElement("img", {
    src: n,
    alt: o
  }) : r.createElement(h, {
    "aria-hidden": "true",
    className: "initials",
    css: {
      color: i || "$text_primary",
      opacity: .8,
      fontSize: t + "px",
      lineHeight: t + "px"
    }
  }, l && void 0 !== l ? l : null));
};

b.defaultProps = {
  size: "small",
  fit: "cover",
  stories: !1,
  shape: "circle",
  icon: null,
  initialsSize: 16
}, b.displayName = "Avatar";

var f = l("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  bg: "$brand_primary",
  m: "$1",
  "& p": {
    color: "$text_inverse",
    textAlign: "center"
  },
  variants: {
    size: {
      large: {
        "& p": {
          fontSize: "$3",
          padding: "0.15rem 0.5rem"
        }
      },
      medium: {
        "& p": {
          fontSize: "$2",
          padding: "0.15rem 0.4rem"
        }
      },
      small: {
        "& p": {
          fontSize: "$1",
          padding: "0.15rem 0.3rem"
        }
      }
    },
    shape: {
      pill: {
        borderRadius: "$4"
      },
      circle: {
        borderRadius: "$round",
        padding: "$1"
      },
      square: {}
    }
  },
  compoundVariants: [{
    shape: "circle",
    size: "small",
    css: {
      width: "16px",
      height: "16px",
      borderRadius: "50%"
    }
  }, {
    shape: "circle",
    size: "medium",
    css: {
      width: "24px",
      height: "24px",
      borderRadius: "50%"
    }
  }, {
    shape: "circle",
    size: "large",
    css: {
      width: "32px",
      height: "32px",
      borderRadius: "50%"
    }
  }]
}),
    x = function x(e) {
  return r.createElement(f, {
    size: e.size,
    shape: e.shape,
    css: {
      backgroundColor: e.bg,
      "& p": {
        color: e.color
      }
    }
  }, r.createElement("p", null, e.text));
};

function v() {
  return (v = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];

      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function y(e, t) {
  if (null == e) return {};
  var r,
      n,
      o = {},
      a = Object.keys(e);

  for (n = 0; n < a.length; n++) {
    t.indexOf(r = a[n]) >= 0 || (o[r] = e[r]);
  }

  return o;
}

x.defaultProps = {
  size: "small",
  shape: "square"
}, x.displayName = "Badge";

var C = ["id", "isOn", "handleToggle", "onColor", "size"],
    E = l("div", {
  ".react-switch-checkbox": {
    height: 0,
    width: 0,
    visibility: "hidden"
  },
  ".react-switch-label": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
    width: "100px",
    height: "50px",
    background: "grey",
    borderRadius: "100px",
    position: "relative",
    transition: "grey .2s"
  },
  ".react-switch-label .react-switch-button": {
    content: "",
    position: "absolute",
    top: "2px",
    left: "2px",
    width: "45px",
    height: "45px",
    borderRadius: "45px",
    transition: "0.2s",
    background: "#fff",
    boxShadow: "0 0 2px 0 rgba(10, 10, 10, 0.29)"
  },
  ".react-switch-checkbox:checked + .react-switch-label .react-switch-button": {
    left: "calc(100% - 2px)",
    transform: "translateX(-100%)"
  },
  ".react-switch-label:active .react-switch-button": {
    width: "60px"
  },
  variants: {
    size: {
      small: {
        ".react-switch-label": {
          width: "50px",
          height: "25px",
          borderRadius: "50px",
          transition: "grey .2s"
        },
        ".react-switch-label .react-switch-button": {
          top: "2px",
          left: "2px",
          width: "20px",
          height: "20px",
          borderRadius: "45px",
          transition: "0.2s"
        },
        ".react-switch-checkbox:checked + .react-switch-label .react-switch-button": {
          left: "calc(100% - 2px)",
          transform: "translateX(-100%)"
        },
        ".react-switch-label:active .react-switch-button": {
          width: "25px"
        }
      },
      large: {
        ".react-switch-label": {
          width: "100px",
          height: "50px",
          borderRadius: "100px",
          transition: "grey .2s"
        },
        ".react-switch-label .react-switch-button": {
          top: "2px",
          left: "2px",
          width: "45px",
          height: "45px",
          borderRadius: "45px",
          transition: "0.2s"
        },
        ".react-switch-checkbox:checked + .react-switch-label .react-switch-button": {
          left: "calc(100% - 2px)",
          transform: "translateX(-100%)"
        },
        ".react-switch-label:active .react-switch-button": {
          width: "60px"
        }
      }
    }
  }
}),
    w = function w(e) {
  var t = e.id,
      n = void 0 === t ? Math.random().toString(36).substr(2, 9) : t,
      o = e.isOn,
      a = e.handleToggle,
      i = e.onColor,
      l = void 0 === i ? "#088845" : i,
      c = e.size,
      d = void 0 === c ? "small" : c,
      s = y(e, C);
  return r.createElement(E, v({
    size: d
  }, s), r.createElement("input", {
    checked: o,
    onChange: a,
    className: "react-switch-checkbox",
    id: n || "react-switch-new",
    type: "checkbox"
  }), r.createElement("label", {
    style: {
      backgroundColor: o ? l : ""
    },
    className: "react-switch-label",
    htmlFor: n || "react-switch-new"
  }, r.createElement("span", {
    className: "react-switch-button"
  })));
};

w.defaultProps = {
  id: Math.random().toString(36).substr(2, 9),
  isOn: !0,
  onColor: "#088845",
  size: "small"
}, w.displayName = "Switch";

var $ = function $(e) {
  return r.createElement("svg", {
    width: "9",
    height: "16",
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M7.26416 14.9878L0.681641 8.56299C0.523926 8.40527 0.440918 8.21436 0.440918 8.00684C0.440918 7.79102 0.532227 7.5835 0.689941 7.45068L7.26416 1.01758C7.40527 0.876465 7.58789 0.793457 7.80371 0.793457C8.23535 0.793457 8.55908 1.12549 8.55908 1.55713C8.55908 1.75635 8.47607 1.95557 8.34326 2.09668L2.30029 8.00684L8.34326 13.917C8.47607 14.0581 8.55908 14.249 8.55908 14.4565C8.55908 14.8882 8.23535 15.2119 7.80371 15.2119C7.58789 15.2119 7.40527 15.1289 7.26416 14.9878Z",
    fill: "dark" === e.theme ? "#AEB4BA" : "#737373"
  }));
},
    _ = function _(e) {
  return r.createElement("svg", {
    width: "9",
    height: "16",
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M1.19629 15.2202C1.41211 15.2202 1.59473 15.1372 1.73584 14.9961L8.31836 8.56299C8.47607 8.40527 8.55908 8.21436 8.55908 8.00684C8.55908 7.79102 8.47607 7.5918 8.31836 7.45068L1.74414 1.02588C1.59473 0.876465 1.41211 0.793457 1.19629 0.793457C0.764648 0.793457 0.440918 1.12549 0.440918 1.55713C0.440918 1.75635 0.523926 1.95557 0.656738 2.09668L6.69971 8.00684L0.656738 13.917C0.523926 14.0581 0.440918 14.249 0.440918 14.4565C0.440918 14.8882 0.764648 15.2202 1.19629 15.2202Z",
    fill: "dark" === e.theme ? "rgba(189, 189, 189, 0.25)" : "#BFBFBF"
  }));
},
    k = function k(e) {
  return r.createElement("svg", {
    width: "21",
    height: "16",
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M3.31982 15.6602H17.6802C19.4233 15.6602 20.2866 14.7969 20.2866 13.0869V2.95166C20.2866 1.2417 19.4233 0.378418 17.6802 0.378418H3.31982C1.58496 0.378418 0.713379 1.2334 0.713379 2.95166V13.0869C0.713379 14.8052 1.58496 15.6602 3.31982 15.6602ZM3.33643 14.3237C2.50635 14.3237 2.0498 13.8838 2.0498 13.0205V3.01807C2.0498 2.15479 2.50635 1.71484 3.33643 1.71484H7.03857V14.3237H3.33643ZM17.6636 1.71484C18.4854 1.71484 18.9502 2.15479 18.9502 3.01807V13.0205C18.9502 13.8838 18.4854 14.3237 17.6636 14.3237H8.3418V1.71484H17.6636ZM5.43652 4.79443C5.69385 4.79443 5.90967 4.57031 5.90967 4.32959C5.90967 4.08057 5.69385 3.86475 5.43652 3.86475H3.66016C3.41113 3.86475 3.18701 4.08057 3.18701 4.32959C3.18701 4.57031 3.41113 4.79443 3.66016 4.79443H5.43652ZM5.43652 6.94434C5.69385 6.94434 5.90967 6.72021 5.90967 6.47119C5.90967 6.22217 5.69385 6.01465 5.43652 6.01465H3.66016C3.41113 6.01465 3.18701 6.22217 3.18701 6.47119C3.18701 6.72021 3.41113 6.94434 3.66016 6.94434H5.43652ZM5.43652 9.08594C5.69385 9.08594 5.90967 8.87842 5.90967 8.62939C5.90967 8.38037 5.69385 8.16455 5.43652 8.16455H3.66016C3.41113 8.16455 3.18701 8.38037 3.18701 8.62939C3.18701 8.87842 3.41113 9.08594 3.66016 9.08594H5.43652Z",
    fill: "dark" === e.theme ? "#AEB4BA" : "#737373"
  }));
},
    F = function F(e) {
  return r.createElement("svg", {
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M1.21094 11.7158H6.78906C7.54492 11.7158 7.91406 11.3408 7.91406 10.5205V6.21973C7.91406 5.48145 7.60938 5.10059 6.98242 5.03613V3.55957C6.98242 1.35059 5.53516 0.28418 4 0.28418C2.46484 0.28418 1.01758 1.35059 1.01758 3.55957V5.06543C0.443359 5.15332 0.0859375 5.52832 0.0859375 6.21973V10.5205C0.0859375 11.3408 0.455078 11.7158 1.21094 11.7158ZM1.96094 3.43652C1.96094 1.96582 2.9043 1.18652 4 1.18652C5.0957 1.18652 6.03906 1.96582 6.03906 3.43652V5.03027L1.96094 5.03613V3.43652Z",
    fill: "dark" === e.theme ? "#AEB4BA" : "#9E9E9E"
  }));
},
    S = function S(e) {
  return r.createElement("svg", {
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M7.5 14.0044C7.90674 14.0044 8.24707 13.6807 8.24707 13.2822V7.76221H13.6094C14.0078 7.76221 14.3481 7.42188 14.3481 7.01514C14.3481 6.6084 14.0078 6.27637 13.6094 6.27637H8.24707V0.748047C8.24707 0.349609 7.90674 0.0258789 7.5 0.0258789C7.09326 0.0258789 6.76123 0.349609 6.76123 0.748047V6.27637H1.39062C0.992188 6.27637 0.651855 6.6084 0.651855 7.01514C0.651855 7.42188 0.992188 7.76221 1.39062 7.76221H6.76123V13.2822C6.76123 13.6807 7.09326 14.0044 7.5 14.0044Z",
    fill: "dark" === e.theme ? "#AEB4BA" : "#737373"
  }));
},
    z = function z(e) {
  return r.createElement("svg", {
    width: "11",
    height: "14",
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M5.2832 6.61523C5.42969 6.61523 5.54102 6.56836 5.62305 6.48047L8.03711 4.05469C8.14258 3.95508 8.18359 3.83789 8.18359 3.70312C8.18359 3.57422 8.13086 3.44531 8.03711 3.35156L5.62305 0.902344C5.54102 0.808594 5.42383 0.761719 5.2832 0.761719C5.01953 0.761719 4.82031 0.972656 4.82031 1.24219C4.82031 1.36523 4.86719 1.48242 4.94922 1.57617L6.51367 3.11133C6.17969 3.05273 5.83984 3.01758 5.5 3.01758C2.62891 3.01758 0.320312 5.32031 0.320312 8.19141C0.320312 11.0684 2.62891 13.377 5.5 13.377C8.37109 13.377 10.6738 11.0684 10.6738 8.19141C10.6738 7.91016 10.4746 7.70508 10.1875 7.70508C9.91211 7.70508 9.73047 7.91016 9.73047 8.19141C9.73047 10.5469 7.84961 12.4336 5.5 12.4336C3.15039 12.4336 1.26367 10.5469 1.26367 8.19141C1.26367 5.8418 3.15039 3.96094 5.5 3.96094C5.94531 3.96094 6.35547 3.99609 6.70703 4.07227L4.95508 5.8125C4.86719 5.90625 4.82031 6.02344 4.82031 6.14648C4.82031 6.41602 5.01953 6.61523 5.2832 6.61523Z",
    fill: "dark" === e.theme ? "#AEB4BA" : "#797979"
  }));
},
    B = function B(e) {
  return r.createElement("svg", {
    width: "15",
    height: "19",
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M7.5 12.2646C7.85693 12.2646 8.15576 11.9658 8.15576 11.6172V3.09229L8.10596 1.84717L8.67041 2.43652L9.92383 3.78125C10.04 3.91406 10.2144 3.98047 10.3721 3.98047C10.7207 3.98047 10.978 3.73145 10.978 3.39111C10.978 3.2168 10.9116 3.08398 10.7871 2.95947L7.98145 0.253418C7.81543 0.0874023 7.66602 0.0292969 7.5 0.0292969C7.33398 0.0292969 7.18457 0.0874023 7.01855 0.253418L4.21289 2.95947C4.08838 3.08398 4.01367 3.2168 4.01367 3.39111C4.01367 3.73145 4.271 3.98047 4.61133 3.98047C4.77734 3.98047 4.95166 3.91406 5.06787 3.78125L6.32959 2.43652L6.89404 1.84717L6.83594 3.09229V11.6172C6.83594 11.9658 7.14307 12.2646 7.5 12.2646ZM2.73535 18.7642H12.2563C13.9912 18.7642 14.8628 17.9009 14.8628 16.1909V7.90674C14.8628 6.19678 13.9912 5.3335 12.2563 5.3335H9.94043V6.66992H12.2314C13.0532 6.66992 13.5264 7.11816 13.5264 7.98145V16.1162C13.5264 16.9795 13.0532 17.4277 12.2314 17.4277H2.75195C1.92188 17.4277 1.46533 16.9795 1.46533 16.1162V7.98145C1.46533 7.11816 1.92188 6.66992 2.75195 6.66992H5.05127V5.3335H2.73535C1.00049 5.3335 0.128906 6.19678 0.128906 7.90674V16.1909C0.128906 17.9009 1.00049 18.7642 2.73535 18.7642Z",
    fill: "dark" === e.theme ? "#AEB4BA" : "#737373"
  }));
},
    A = function A(e) {
  return r.createElement("svg", {
    width: "15",
    height: "18",
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M7.5 17.6147C7.63281 17.6147 7.84863 17.5649 8.05615 17.4487C12.7793 14.8008 14.3979 13.6802 14.3979 10.6504V4.30029C14.3979 3.42871 14.0244 3.15479 13.3188 2.85596C12.3394 2.44922 9.17676 1.31201 8.19727 0.97168C7.97314 0.896973 7.73242 0.847168 7.5 0.847168C7.26758 0.847168 7.02686 0.913574 6.81104 0.97168C5.83154 1.25391 2.66064 2.45752 1.68115 2.85596C0.983887 3.14648 0.602051 3.42871 0.602051 4.30029V10.6504C0.602051 13.6802 2.229 14.7925 6.94385 17.4487C7.15967 17.5649 7.36719 17.6147 7.5 17.6147ZM7.83203 2.2583C9.08545 2.75635 11.5176 3.63623 12.8042 4.07617C13.0283 4.15918 13.0781 4.27539 13.0781 4.55762V10.3433C13.0781 12.9082 11.8496 13.5806 8.01465 15.9131C7.77393 16.0625 7.64111 16.104 7.5083 16.1123V2.18359C7.59131 2.18359 7.69922 2.2085 7.83203 2.2583Z",
    fill: "dark" === e.theme ? "#AEB4BA" : "#737373"
  }));
},
    D = function D(e) {
  return r.createElement("svg", {
    width: "19",
    height: "18",
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("path", {
    d: "M3.32422 13.8711H4.74365V15.1411C4.74365 16.8511 5.60693 17.7144 7.3501 17.7144H15.6841C17.4106 17.7144 18.2822 16.8511 18.2822 15.1411V6.74072C18.2822 5.03076 17.4106 4.16748 15.6841 4.16748H14.2563V2.89746C14.2563 1.1875 13.3848 0.324219 11.6582 0.324219H3.32422C1.58105 0.324219 0.717773 1.1875 0.717773 2.89746V11.2979C0.717773 13.0078 1.58105 13.8711 3.32422 13.8711ZM3.34082 12.5347C2.51074 12.5347 2.0542 12.0864 2.0542 11.2231V2.97217C2.0542 2.10889 2.51074 1.66064 3.34082 1.66064H11.6333C12.4551 1.66064 12.9199 2.10889 12.9199 2.97217V4.16748H7.3501C5.60693 4.16748 4.74365 5.02246 4.74365 6.74072V12.5347H3.34082ZM7.3667 16.3779C6.54492 16.3779 6.08008 15.9297 6.08008 15.0664V6.81543C6.08008 5.95215 6.54492 5.50391 7.3667 5.50391H15.6592C16.481 5.50391 16.9458 5.95215 16.9458 6.81543V15.0664C16.9458 15.9297 16.481 16.3779 15.6592 16.3779H7.3667Z",
    fill: "dark" === e.theme ? "#AEB4BA" : "#737373"
  }));
},
    H = function H() {
  return r.createElement("svg", {
    width: "52",
    height: "12",
    viewBox: "0 0 52 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, r.createElement("g", {
    filter: "url(#filter0_i)"
  }, r.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#EE6A5F"
  })), r.createElement("path", {
    d: "M11.75 6C11.75 9.17564 9.17564 11.75 6 11.75C2.82436 11.75 0.25 9.17564 0.25 6C0.25 2.82436 2.82436 0.25 6 0.25C9.17564 0.25 11.75 2.82436 11.75 6Z",
    stroke: "#CE5347",
    "stroke-width": "0.5"
  }), r.createElement("g", {
    filter: "url(#filter1_i)"
  }, r.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M26 12C29.3137 12 32 9.31371 32 6C32 2.68629 29.3137 0 26 0C22.6863 0 20 2.68629 20 6C20 9.31371 22.6863 12 26 12Z",
    fill: "#F5BD4F"
  })), r.createElement("path", {
    d: "M31.75 6C31.75 9.17564 29.1756 11.75 26 11.75C22.8244 11.75 20.25 9.17564 20.25 6C20.25 2.82436 22.8244 0.25 26 0.25C29.1756 0.25 31.75 2.82436 31.75 6Z",
    stroke: "#D6A243",
    "stroke-width": "0.5"
  }), r.createElement("g", {
    filter: "url(#filter2_i)"
  }, r.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M46 12C49.3137 12 52 9.31371 52 6C52 2.68629 49.3137 0 46 0C42.6863 0 40 2.68629 40 6C40 9.31371 42.6863 12 46 12Z",
    fill: "#61C454"
  })), r.createElement("path", {
    d: "M51.75 6C51.75 9.17564 49.1756 11.75 46 11.75C42.8244 11.75 40.25 9.17564 40.25 6C40.25 2.82436 42.8244 0.25 46 0.25C49.1756 0.25 51.75 2.82436 51.75 6Z",
    stroke: "#58A942",
    "stroke-width": "0.5"
  }), r.createElement("defs", null, r.createElement("filter", {
    id: "filter0_i",
    x: "0",
    y: "0",
    width: "12",
    height: "12",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, r.createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), r.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), r.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), r.createElement("feOffset", null), r.createElement("feGaussianBlur", {
    stdDeviation: "3"
  }), r.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: "-1",
    k3: "1"
  }), r.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"
  }), r.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), r.createElement("filter", {
    id: "filter1_i",
    x: "20",
    y: "0",
    width: "12",
    height: "12",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, r.createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), r.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), r.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), r.createElement("feOffset", null), r.createElement("feGaussianBlur", {
    stdDeviation: "3"
  }), r.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: "-1",
    k3: "1"
  }), r.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"
  }), r.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), r.createElement("filter", {
    id: "filter2_i",
    x: "40",
    y: "0",
    width: "12",
    height: "12",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, r.createElement("feFlood", {
    "flood-opacity": "0",
    result: "BackgroundImageFix"
  }), r.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), r.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), r.createElement("feOffset", null), r.createElement("feGaussianBlur", {
    stdDeviation: "3"
  }), r.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: "-1",
    k3: "1"
  }), r.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"
  }), r.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }))));
},
    R = l("div", {
  display: "flex",
  padding: "$2",
  borderTopLeftRadius: "$3",
  borderTopRightRadius: "$3"
}),
    N = l("div", {
  py: "2px",
  px: "$2",
  display: "flex",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  borderRadius: "$2",
  "& small": {
    ml: "$1"
  },
  "& .url": {
    display: "flex",
    alignItems: "center"
  },
  "& .lock > *": {
    width: "10px",
    height: "10px"
  },
  "& .refresh > *": {
    width: "12px",
    height: "12px"
  }
}),
    I = l("div", {
  flex: 1,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "& .left": {
    display: "flex"
  },
  "& .traffic_light > *": {
    mx: "$2",
    width: "36px",
    height: "14px"
  },
  "& .chevrons > *": {
    mx: "$2",
    width: "8px",
    height: "12px"
  },
  "& .layout > *": {
    mx: "$3",
    width: "16px",
    height: "12px"
  },
  "& .shield > *": {
    mx: "$3",
    width: "14px",
    height: "14px"
  }
}),
    T = l("div", {
  flex: 1,
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  "& > *": {
    mx: "$2",
    width: "12px",
    height: "12px"
  }
}),
    V = function V(e) {
  var t = e.theme;
  return r.createElement(R, {
    css: {
      backgroundColor: "dark" === t ? "rgba(38, 43, 47, 0.53)" : "rgba(255, 255, 255, 0.78)"
    }
  }, r.createElement(I, null, r.createElement("div", {
    className: "left"
  }, r.createElement("span", {
    className: "traffic_light"
  }, r.createElement(H, null)), r.createElement("span", {
    className: "layout"
  }, r.createElement(k, {
    theme: t
  })), r.createElement("span", {
    className: "chevrons"
  }, r.createElement($, {
    theme: t
  }), r.createElement(_, {
    theme: t
  }))), r.createElement("span", {
    className: "shield"
  }, r.createElement(A, {
    theme: t
  }))), r.createElement(N, {
    css: {
      backgroundColor: "dark" === t ? "rgba(66, 75, 82, 0.18)" : "rgba(0, 0, 0, 0.05)"
    }
  }, r.createElement("span", null), r.createElement("div", {
    className: "url"
  }, r.createElement("span", {
    className: "lock"
  }, r.createElement(F, {
    theme: t
  })), r.createElement("small", {
    style: {
      color: "dark" === t ? "#ccc" : "#000"
    }
  }, "camara.space")), r.createElement("span", {
    className: "refresh"
  }, r.createElement(z, {
    theme: t
  }))), r.createElement(T, null, r.createElement(B, {
    theme: t
  }), r.createElement(S, {
    theme: t
  }), r.createElement(D, {
    theme: t
  })));
},
    L = l("div", {
  backgroundRepeat: "no-repeat",
  backgroundSize: "100%",
  width: "100%",
  display: "flex",
  flex: 1,
  flexDirection: "column",
  alignItems: "center"
}),
    M = l("div", {
  width: "90%",
  height: "90%",
  display: "flex",
  flexDirection: "column",
  paddingBottom: "$5",
  "& span": {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  "& span > small": {
    fontWeight: "500",
    color: "$text_primary",
    marginRight: "$1"
  }
}),
    W = l("div", {
  display: "flex",
  flexDirection: "column",
  flex: 1
}),
    j = l("div", {
  height: "100vh",
  backgroundColor: "$bg_primary",
  borderBottomLeftRadius: "$3",
  borderBottomRightRadius: "$3",
  overflowY: "auto",
  px: "$4",
  py: "$3",
  "&::-webkit-scrollbar": {
    width: "10px"
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: "10px",
    webkitBoxShadow: "inset 0 0 6px #777",
    boxShadow: "inset 0 0 6px #777"
  },
  "&::-webkit-scrollbar-thumb": {
    borderRadius: "10px",
    webkitBoxShadow: "inset 0 0 6px #777",
    boxShadow: "inset 0 0 6px #777"
  }
}),
    P = l("div", {
  variants: {
    center: {
      true: {
        margin: "0 auto"
      }
    },
    debug: {
      true: {
        border: "1px solid red"
      }
    }
  }
}),
    Z = function Z(e) {
  return r.createElement(P, {
    role: e.role,
    center: e.center,
    debug: e.debug,
    css: {
      width: e.width,
      height: e.height,
      backgroundColor: e.bg,
      m: e.m,
      mx: e.mx,
      my: e.my,
      mb: e.mb,
      ml: e.ml,
      mr: e.mr,
      mt: e.mt,
      p: e.p,
      pb: e.pb,
      pl: e.pl,
      pr: e.pr,
      pt: e.pt,
      px: e.px,
      py: e.py
    }
  }, e.children);
};

Z.defaultProps = {}, Z.displayName = "Box";
var O = ["children", "disabled", "block", "danger", "size", "bg", "color"],
    q = l("button", {
  position: "relative",
  fontFamily: "$body",
  fontSize: "$4",
  fontWeight: "$medium",
  borderRadius: "$2",
  borderWidth: "$1",
  borderStyle: "solid",
  m: "$1",
  appearance: "none",
  cursor: "pointer",
  variants: {
    variant: {
      primary: {
        backgroundColor: "$button_primary",
        color: "$button_text",
        borderColor: "transparent",
        "&:hover": {
          backgroundColor: "$button_hover"
        },
        "&:active, &:focus": {
          backgroundColor: "$button_focus"
        },
        "&:disabled": {
          color: "$text_disabled",
          backgroundColor: "$ui_disabled",
          borderColor: "$ui_disabled",
          cursor: "not-allowed"
        }
      },
      secondary: {
        backgroundColor: "transparent",
        color: "$button_primary",
        border: "1px solid $button_primary",
        "&:hover": {
          borderColor: "$button_hover",
          backgroundColor: "$button_secondary"
        },
        "&:active, &:focus": {
          color: "$button_text",
          borderColor: "$button_focus",
          backgroundColor: "$button_focus"
        },
        "&:disabled": {
          color: "$text_disabled",
          borderColor: "$ui_disabled",
          cursor: "not-allowed"
        }
      },
      ghost: {
        backgroundColor: "transparent",
        color: "$button_primary",
        borderColor: "transparent",
        "&:hover": {
          color: "$button_hover",
          backgroundColor: "$bgHighlight"
        },
        "&:active, &:focus": {
          color: "$button_focus",
          backgroundColor: "$bgHighlight"
        },
        "&:disabled": {
          color: "$text_disabled",
          cursor: "not-allowed"
        }
      }
    },
    size: {
      large: {
        px: "$5",
        py: "$3"
      },
      medium: {
        px: "$4",
        py: "$2"
      },
      small: {
        px: "$3",
        py: "$1",
        fontSize: "$2"
      }
    },
    danger: {
      true: {}
    },
    pill: {
      true: {
        borderRadius: "$round"
      }
    },
    block: {
      true: {
        display: "block",
        width: "100%"
      }
    }
  },
  compoundVariants: [{
    variant: "primary",
    danger: "true",
    css: {
      backgroundColor: "$button_danger",
      "&:hover": {
        backgroundColor: "$button_dangerHover"
      },
      "&:active, &:focus": {
        backgroundColor: "$button_dangerFocus"
      },
      "&:disabled": {
        color: "$text_disabled",
        backgroundColor: "$ui_disabled",
        borderColor: "$ui_disabled",
        cursor: "not-allowed"
      }
    }
  }, {
    variant: "secondary",
    danger: "true",
    css: {
      color: "$button_danger",
      borderColor: "$button_danger",
      "&:hover": {
        color: "$button_dangerHover",
        borderColor: "$button_danger_hover",
        backgroundColor: "$button_danger_sec_hover"
      },
      "&:active, &:focus": {
        color: "$button_text",
        borderColor: "$button_dangerFocus",
        backgroundColor: "$button_danger"
      },
      "&:disabled": {
        color: "$text_disabled",
        borderColor: "$ui_disabled",
        cursor: "not-allowed"
      }
    }
  }, {
    variant: "ghost",
    danger: "true",
    css: {
      color: "$button_danger",
      "&:hover": {
        color: "$button_dangerHover"
      },
      "&:active, &:focus": {
        color: "$button_dangerFocus"
      },
      "&:disabled": {
        color: "$text_disabled",
        cursor: "not-allowed"
      }
    }
  }],
  defaultVariants: {
    size: "medium",
    variant: "primary"
  }
}),
    U = r.forwardRef(function (e, t) {
  var n = e.children,
      o = e.disabled,
      i = e.block,
      l = e.danger,
      c = e.size,
      d = e.bg,
      s = e.color,
      u = y(e, O);
  return r.createElement(q, v({
    ref: t,
    disabled: o,
    danger: l,
    size: c,
    block: i
  }, u, {
    css: {
      backgroundColor: d,
      color: s,
      "&:hover": {
        backgroundColor: d ? a.darken(.05, "" + d) : ""
      }
    }
  }), n);
});
U.defaultProps = {
  variant: "primary",
  size: "medium"
}, U.displayName = "Button";

var G = c({
  "*, *:before, *:after ": {
    boxSizing: "border-box",
    margin: 0,
    padding: 0
  },
  html: {
    fontSize: "$4",
    boxSizing: "border-box",
    background: "$bg_primary"
  },
  body: {
    background: "$bg_primary",
    color: "$text_primary",
    fontFamily: "$body",
    transition: "all 0.50s linear"
  },
  a: {
    color: "$brand_primary",
    cursor: "pointer"
  }
}),
    X = ["children", "elevate", "bordered", "width", "height", "round", "bg"],
    Y = l("div", {
  bg: "$bg_secondary",
  p: "$3",
  lineHeight: "$copy",
  variants: {
    elevate: {
      true: {
        boxShadow: "$bg_shadow"
      }
    },
    bordered: {
      true: {
        border: "1.5px solid $ui_border"
      }
    },
    round: {
      true: {
        borderRadius: "$3"
      }
    }
  }
}),
    J = function J(e) {
  var t = e.children,
      n = e.elevate,
      o = e.bordered,
      a = e.width,
      i = e.height,
      l = e.round,
      c = e.bg,
      d = y(e, X);
  return r.createElement(Y, v({
    css: {
      height: i && i,
      width: a && a,
      bg: c && c
    },
    elevate: n,
    bordered: o,
    round: l
  }, d), t);
};

J.displayName = "Card";

var K = ["type"],
    Q = l("hr", {
  display: "block",
  border: "1px solid $ui_border",
  variants: {
    type: {
      dashed: {
        borderStyle: "dashed"
      },
      dotted: {
        borderStyle: "dotted"
      },
      normal: {
        borderStyle: "solid"
      }
    }
  }
}),
    ee = function ee(e) {
  var t = e.type,
      n = y(e, K);
  return r.createElement(Q, v({
    type: t
  }, n));
};

ee.defaultProps = {
  type: "normal"
}, ee.displayName = "Divider";

var te = l("div", {
  display: "flex",
  variants: {
    debug: {
      true: {
        border: "1px solid red"
      }
    }
  }
}),
    re = function re(e) {
  return r.createElement(te, {
    debug: e.debug,
    css: {
      justifyContent: e.justifyContent,
      flexDirection: e.direction,
      alignContent: e.alignContent,
      alignItems: e.alignItems,
      alignSelf: e.alignSelf,
      wrap: e.wrap,
      width: e.width,
      my: e.my,
      mx: e.mx,
      py: e.py,
      px: e.px
    }
  }, e.children);
};

re.displayName = "Flex";

var ne = {
  color: "$text_primary",
  margin: 0,
  padding: 0,
  fontWeight: "$bold"
},
    oe = l("h1", v({}, ne)),
    ae = l("h2", v({}, ne)),
    ie = l("h3", v({}, ne)),
    le = l("h4", v({}, ne)),
    ce = function ce(e) {
  var t = e.children,
      n = {
    fontWeight: e.thin ? 300 : e.fontWeight,
    textAlign: e.textAlign,
    color: e.color,
    my: e.noWhiteSpace ? 0 : "$2"
  };

  switch (e.level) {
    case 1:
      return r.createElement(oe, {
        css: v({}, n)
      }, t);

    case 2:
      return r.createElement(ae, {
        css: v({}, n)
      }, t);

    case 3:
      return r.createElement(ie, {
        css: v({}, n)
      }, t);

    case 4:
      return r.createElement(le, {
        css: v({}, n)
      }, t);

    default:
      return r.createElement(oe, {
        css: v({}, n)
      }, t);
  }
};

ce.defaultProps = {
  level: 1,
  textAlign: "left",
  fontWeight: "bold"
}, ce.displayName = "Heading";

var de = ["src", "alt", "loading", "fit", "width", "height"],
    se = l("img", {
  display: "block"
}),
    ue = function ue(e) {
  var t = e.src,
      n = e.alt,
      o = e.loading,
      a = e.fit,
      i = e.width,
      l = void 0 === i ? "100%" : i,
      c = e.height,
      d = void 0 === c ? "auto" : c,
      s = y(e, de);
  return r.createElement(se, v({
    src: t,
    alt: n,
    width: l,
    height: d,
    loading: o
  }, s, {
    css: {
      objectFit: a
    }
  }));
};

ue.defaultProps = {
  src: "https://source.unsplash.com/V_WBdOLOgJU/900x800",
  width: "100%",
  alt: "woman in black and white crew neck long sleeve shirt wearing purple knit cap",
  fit: "cover",
  loading: "lazy"
}, ue.displayName = "Image";

var me = l("div", {
  "& .requiredText": {
    color: "red",
    display: "inline"
  },
  "& .helperText": {
    display: "block",
    color: "#999",
    margin: "0 8px"
  },
  "& label": {
    display: "block",
    margin: "8px 0",
    color: "$text_secondary",
    fontSize: "$3"
  },
  "& input": {
    display: "inline-block",
    backgroundColor: "$bg_secondary",
    color: "$text_secondary",
    padding: "0.65rem 0.5rem",
    border: "1px solid $ui_border",
    borderRadius: "$2",
    outlineColor: "$brand_primary",
    fontSize: "$3",
    minWidth: "250px"
  },
  "& input::placeholder": {
    color: "$text_placeholder",
    fontSize: "$3"
  },
  "& input:active": {
    border: "2px solid $brand_primary",
    outline: "none"
  },
  "& input:focus": {
    border: "2px solid $brand_primary",
    outline: "none"
  },
  variants: {
    inline: {
      true: {
        display: "inline"
      }
    }
  }
}),
    pe = function pe(e) {
  var t = e.label,
      n = e.name,
      o = e.placeholder,
      a = e.type,
      i = e.disabled,
      l = e.helperText;
  return r.createElement(me, null, t && r.createElement("label", {
    htmlFor: n
  }, e.required ? r.createElement("span", {
    className: "requiredText"
  }, "*") : null, " ", t), r.createElement("input", {
    type: a,
    name: n,
    placeholder: o,
    disabled: i
  }), l ? r.createElement("small", {
    className: "helperText"
  }, l) : null);
};

pe.defaultProps = {}, pe.displayName = "InputField";

var he = l("div", {
  "a > div:hover": {
    backgroundColor: "$btn_sec_hover"
  }
}),
    ge = l("div", {
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "1px solid $ui_border",
  padding: "$3"
}),
    be = l("a", {
  textDecoration: "none"
}),
    fe = l("div", {
  height: 40,
  px: "$3",
  backgroundColor: "$brand_primary"
}),
    xe = function xe() {
  return r.createElement(fe, null, r.createElement(re, {
    justifyContent: "space-between",
    alignItems: "center"
  }, r.createElement(ce, {
    fontWeight: "normal",
    color: "$text_inverse",
    level: 4
  }, "Feedback Tower"), r.createElement(re, null, r.createElement(b, {
    size: "tiny",
    imageSrc: "https://res.cloudinary.com/beaniegram/image/upload/v1621233700/iecbxwcmdgvchbalxety.png",
    imageAlt: "author's portrait"
  }), r.createElement(re, {
    alignItems: "center"
  }, r.createElement(Ae, {
    mx: "$1",
    size: "small",
    color: "$text_inverse"
  }, "PreshOnyee"), r.createElement(n.ChevronDown, {
    color: "#fff",
    size: 16
  })))));
},
    ve = l("div", {
  height: "100%",
  "a > div:hover": {
    backgroundColor: "$btn_sec_hover"
  }
}),
    ye = l("div", {
  borderRadius: "$round",
  width: "12px",
  height: "12px",
  my: "$1"
}),
    Ce = function Ce(e) {
  return r.createElement(ye, {
    css: {
      backgroundColor: e.hidden ? "none" : "$brand_primary"
    }
  });
},
    Ee = l("div", {
  fontFamily: "$body",
  "& li": {
    listStyle: "none"
  },
  "& ul": {
    border: "1px solid $ui_border",
    borderRadius: "$2",
    marginTop: "$1",
    boxShadow: "$bg_shadow",
    backgroundColor: "$bg_primary"
  }
}),
    we = l("div", {
  backgroundColor: "$bg_primary",
  color: "$text_primary",
  border: "1px solid $ui_border",
  borderRadius: "$2",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minWidth: "100px",
  height: "$3",
  padding: "$3 0",
  fontWeight: "$regular",
  "& div > p": {
    paddingLeft: "12px",
    fontSize: "$3"
  },
  "& svg": {
    paddingRight: "$2"
  }
}),
    $e = l("button", {
  fontFamily: "$body",
  border: "none",
  borderBottom: "0.5px solid $ui_border",
  backgroundColor: "$bg_primary",
  color: "$text_primary",
  textAlign: "left",
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  margin: "$1 0",
  padding: "$1 0",
  cursor: "pointer",
  "& span": {
    width: "$3",
    height: "$3",
    marginLeft: "12px",
    marginRight: "12px"
  },
  "& span > img": {
    width: "$3",
    height: "$3"
  },
  "& div": {
    display: "flex",
    flexDirection: "column",
    alignSelf: "center",
    width: "100%",
    "& p": {
      paddingRight: "$3",
      fontSize: "$2",
      fontWeight: "$medium"
    },
    "& small": {
      marginTop: "2px",
      fontSize: "$1",
      lineHeight: "$copy",
      color: "$text_secondary"
    }
  },
  "&:hover": {
    backgroundColor: "$button_secondary"
  }
}),
    _e = l("div", {}),
    ke = function ke(e) {
  return t.createElement(_e, null, e.children);
};

ke.displayName = "Spacer";

var Fe = l("li", {}),
    Se = l("div", {
  borderRadius: "$2",
  fontWeight: "500",
  textAlign: "center",
  display: "inline-block",
  verticalAlign: "middle",
  variants: {
    size: {
      small: {
        fontSize: "10px",
        padding: "0.15rem 0.3rem"
      },
      medium: {
        fontSize: "12px",
        padding: "0.15rem 0.4rem"
      },
      large: {
        fontSize: "14px",
        padding: "0.075rem 0.5rem"
      }
    }
  }
}),
    ze = function ze(e) {
  var t = e.children,
      n = e.color;
  return r.createElement(Se, {
    size: e.size,
    css: {
      border: "1.5px solid " + n,
      color: a.darken(.2, "" + n),
      backgroundColor: a.lighten(.25, "" + n)
    }
  }, t.toUpperCase());
};

ze.defaultProps = {
  color: "#BB65FF",
  size: "small",
  children: "Tag"
}, ze.displayName = "Tag";
var Be = l("p", {
  fontWeight: "$regular",
  lineHeight: "$copy",
  color: "$text_primary",
  mt: 0,
  mb: 0,
  variants: {
    variant: {
      body: {
        fontSize: "$3",
        my: "$2",
        mx: 0
      },
      caption: {
        fontSize: "$2"
      },
      hint: {
        fontSize: 0
      },
      label: {
        fontSize: "$2"
      },
      overline: {
        textTransform: "uppercase",
        fontSize: "$2",
        letterSpacing: "$overline"
      }
    },
    size: {
      large: {
        fontSize: "$5"
      },
      medium: {
        fontSize: "$4"
      },
      small: {
        fontSize: "$3"
      }
    },
    inline: {
      true: {
        display: "inline"
      }
    },
    underline: {
      true: {
        textDecoration: "underline"
      }
    },
    strike: {
      true: {
        textDecoration: "line-through"
      }
    }
  }
}),
    Ae = t.forwardRef(function (e, t) {
  return r.createElement(Be, {
    ref: t,
    variant: e.variant,
    inline: e.inline,
    size: e.size,
    strike: e.strike,
    underline: e.underline,
    css: {
      color: e.color,
      my: e.my,
      mx: e.mx,
      py: e.py,
      px: e.px,
      fontSize: e.fontSize,
      fontWeight: e.fontWeight,
      fontStyle: e.fontStyle,
      textAlign: e.textAlign
    }
  }, e.children);
});
Ae.defaultProps = {
  variant: "body",
  size: "medium"
}, Ae.displayName = "Text";

var De = ["label", "helperText", "rows", "name", "placeholder", "disabled", "required", "wrap", "maxlength", "resizable"],
    He = l("div", {
  "& .requiredText": {
    color: "red",
    display: "inline"
  },
  "& .helperText": {
    display: "block",
    color: "#999",
    margin: "0 8px"
  },
  label: {
    display: "block",
    margin: "8px 0",
    color: "$text_secondary",
    fontSize: "$3"
  },
  "& textarea": {
    display: "inline-block",
    backgroundColor: "$bg_secondary",
    color: "$text_secondary",
    padding: "0.65rem 0.5rem",
    border: "1px solid $ui_border",
    borderRadius: "$2",
    outlineColor: "$brand_primary",
    fontSize: "$3",
    minWidth: "250px"
  },
  "& textarea::placeholder": {
    color: "$text_placeholder",
    fontFamily: "sans-serif",
    fontSize: "$3"
  },
  "& textarea:active": {
    outline: "none",
    border: "2px solid $brand_primary"
  },
  "& textarea:focus": {
    outline: "none",
    border: "2px solid $brand_primary"
  }
}),
    Re = function Re(e) {
  var t = e.label,
      n = e.helperText,
      o = e.rows,
      a = e.name,
      i = e.placeholder,
      l = e.disabled,
      c = e.required,
      d = e.wrap,
      s = e.maxlength,
      u = e.resizable,
      m = y(e, De);
  return r.createElement(He, null, t && r.createElement("label", {
    htmlFor: a
  }, c ? r.createElement("span", {
    className: "requiredText"
  }, "*") : null, " ", t), r.createElement("textarea", v({
    "data-testid": "textarea-component",
    rows: o,
    placeholder: i,
    disabled: l,
    required: c,
    wrap: d,
    maxLength: s,
    style: {
      resize: u ? "both" : "none"
    }
  }, m)), n ? r.createElement("small", {
    className: "helperText"
  }, n) : null);
};

Re.defaultProps = {
  rows: 4,
  wrap: "hard"
}, Re.displayName = "TextArea";
var Ne = l("div", {
  display: "flex",
  height: "100%",
  overflowY: "auto"
}),
    Ie = l("div", {
  display: "flex",
  flexDirection: "column",
  backgroundColor: "$bg_secondary",
  borderRight: "2px solid $ui_border"
}),
    Te = l("div", {
  flex: 2,
  borderRight: "2px solid $ui_border"
}),
    Ve = l("div", {
  flex: 3,
  width: "40%"
});
exports.Accordion = function (e) {
  var t = e.title,
      o = e.children,
      a = e.prefix,
      i = e.expanded,
      l = void 0 !== i && i,
      c = e.icon,
      d = r.useState(!1),
      u = d[0],
      m = d[1],
      p = r.useState("0px"),
      h = p[0],
      g = p[1],
      b = r.useState(!1),
      f = b[0],
      x = b[1],
      v = r.useState(""),
      y = v[0],
      C = v[1],
      E = r.useState("0px"),
      w = E[0],
      $ = E[1],
      _ = r.useRef();

  return r.useEffect(function () {
    l && (x(!0), C("accordion-icon rotate"), $("500px"));
  }, []), r.createElement(s, null, r.createElement("div", {
    id: "accordion-title"
  }, r.createElement("h2", null, r.createElement("button", {
    id: "accordion-button",
    className: "accordion " + (u ? "" : "active"),
    "aria-controls": "accordion-content",
    "aria-expanded": u,
    onClick: f ? function () {
      x(!1), C(""), $("0px");
    } : function () {
      m(!u), g(u ? "0px" : _.current.scrollHeight + "px");
    }
  }, r.createElement("p", {
    className: "accordion-title"
  }, a && r.createElement("span", null, a), t), c ? r.createElement("span", {
    className: "accordion-icon " + (u ? "accordion-icon rotate" : "") + " " + y
  }, c) : r.createElement(n.ChevronRight, {
    className: "accordion-icon " + (u ? "accordion-icon rotate" : "") + " " + y,
    color: "#777",
    size: 16
  })))), r.createElement("div", {
    id: "accordion-content",
    ref: _,
    "aria-labelledby": "accordion-button",
    role: "region",
    className: "accordion-content",
    style: {
      maxHeight: f ? "" + w : "" + h
    }
  }, r.createElement("p", {
    className: "accordion-text"
  }, o)));
}, exports.Anchor = m, exports.Avatar = b, exports.Badge = x, exports.Box = Z, exports.BrowserWindow = function (e) {
  var o = e.children,
      a = e.docs,
      i = t.useState(!1),
      l = i[0],
      c = i[1];
  return r.createElement(L, {
    className: l ? d : "light",
    css: {
      height: a ? "100%" : "auto",
      backgroundImage: l ? 'url("https://res.cloudinary.com/beaniegram/image/upload/c_scale,h_1000,w_1000/v1623835103/Personal%20Site/macOS-Big-Sur-Vector-Wave-Dark-Wallpaper-iDownloadBlog_lauxpt.jpg")' : 'url("https://res.cloudinary.com/beaniegram/image/upload/c_scale,h_1000,w_1000/v1623835298/Personal%20Site/macOS-Big-Sur-Vector-Wave-Wallpaper-iDownloadBlog_gfmhsj.jpg")'
    }
  }, r.createElement(M, null, r.createElement("span", null, r.createElement("div", null, r.createElement(l ? n.Moon : n.Sun, {
    fill: l ? "#bbb" : "#000",
    size: 16,
    color: l ? "#bbb" : "#000"
  })), r.createElement("span", null, r.createElement("small", null, "Dark Mode"), " ", r.createElement(w, {
    css: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "1rem 0"
    },
    id: Math.random().toString(),
    onColor: "#EF476F",
    isOn: l,
    handleToggle: function handleToggle() {
      return c(!l);
    }
  }))), r.createElement(W, {
    css: {
      display: a ? "block" : "flex"
    }
  }, r.createElement(V, {
    theme: l ? "dark" : "light"
  }), r.createElement(j, {
    css: {
      height: a ? "100%" : "100vh",
      minHeight: a ? "320px" : "auto",
      maxHeight: a ? "640px" : "auto"
    }
  }, o))));
}, exports.Button = U, exports.CamaraTheme = function (e) {
  var t = e.children,
      n = e.theme;
  return G(), r.createElement("div", {
    className: "dark" === n ? d : "light"
  }, t);
}, exports.Card = J, exports.Divider = ee, exports.Flex = re, exports.Heading = ce, exports.Image = ue, exports.InputField = pe, exports.List = function (e) {
  return r.createElement(he, null, e.listData.map(function (e) {
    return r.createElement(be, {
      key: e.id,
      href: ""
    }, r.createElement(ge, null, r.createElement(Z, null, r.createElement(Ce, e.unread ? null : {
      hidden: !0
    })), r.createElement(Z, {
      width: "80%"
    }, r.createElement(ce, {
      noWhiteSpace: !0,
      level: 4,
      fontWeight: e.unread ? "bold" : 300
    }, e.subject), r.createElement(Ae, {
      fontWeight: e.unread ? 500 : 300,
      fontSize: 14,
      color: "#777"
    }, e.message), r.createElement(ze, {
      color: e.tag[0].color
    }, e.tag[0].name)), r.createElement(re, {
      width: "15%",
      direction: "column",
      alignItems: "flex-end"
    }, r.createElement(Ae, {
      color: e.unread ? "$brand_primary" : "#777",
      fontSize: 10,
      fontWeight: 500
    }, e.date), r.createElement(Z, null, r.createElement(b, {
      username: e.initials,
      bg: e.color,
      color: "#fff"
    })))));
  }));
}, exports.NavBar = xe, exports.NavigationPane = function (e) {
  return function (e) {
    if (null == e) throw new TypeError("Cannot destructure undefined");
  }(e), r.createElement(ve, null, r.createElement(m, {
    href: "",
    underline: !1
  }, r.createElement(re, {
    px: "$2",
    alignItems: "center",
    justifyContent: "space-between"
  }, r.createElement(re, {
    alignItems: "center"
  }, r.createElement(n.Inbox, {
    color: "#1a73e8",
    size: 20
  }), r.createElement(Ae, {
    mx: "$1",
    fontWeight: 500,
    size: "small"
  }, "FeedBox")), r.createElement(Ae, null, "2"))), r.createElement(m, {
    href: "",
    underline: !1
  }, r.createElement(re, {
    px: "$2",
    alignItems: "center"
  }, r.createElement(re, {
    alignItems: "center",
    justifyContent: "space-between"
  }, r.createElement(n.Star, {
    color: "orange",
    size: 20
  }), r.createElement(Ae, {
    mx: "$1",
    fontWeight: 500,
    size: "small"
  }, "Starred")), r.createElement(Ae, null))), r.createElement(Z, {
    my: "$4"
  }, r.createElement(re, {
    px: "$2",
    alignItems: "center",
    justifyContent: "space-between"
  }, r.createElement(ce, {
    level: 4
  }, "Tags"), r.createElement(n.Plus, {
    color: "#777",
    size: 20
  })), r.createElement(Z, null, [{
    id: 1,
    name: "Design",
    count: 1,
    color: "#ffc107"
  }, {
    id: 2,
    name: "Feedback From Testers",
    count: 2,
    color: "orange"
  }, {
    id: 3,
    name: "Bug Reports",
    count: 0,
    color: "pink"
  }, {
    id: 4,
    name: "Feature Requests",
    count: 0,
    color: "purple"
  }, {
    id: 5,
    name: "Questions",
    count: 0,
    color: "#00b2ff"
  }, {
    id: 6,
    name: "Rebrand",
    count: 0,
    color: "teal"
  }, {
    id: 7,
    name: "Inspiration",
    count: 0,
    color: "tomato"
  }].map(function (e) {
    return r.createElement(m, {
      key: e.id,
      href: "",
      underline: !1
    }, r.createElement(Z, {
      my: "$1",
      px: "$2"
    }, r.createElement(re, {
      justifyContent: "space-between"
    }, r.createElement(re, {
      alignItems: "center"
    }, r.createElement(n.Tag, {
      color: e.color,
      size: 16
    }), r.createElement(Ae, {
      color: "$text_secondary",
      px: "$2",
      size: "small",
      fontWeight: 500
    }, e.name)), r.createElement(Ae, {
      color: "$text_secondary",
      size: "small",
      fontWeight: 500
    }, e.count >= 1 && e.count))));
  }))));
}, exports.NotificationDot = Ce, exports.Select = function (e) {
  var o = e.placeholder,
      a = void 0 === o ? "Choose from..." : o,
      i = e.options,
      l = e.extended,
      c = e.onSelect,
      d = e.multiple,
      s = t.useState(!1),
      u = s[0],
      m = s[1],
      p = t.useRef(null),
      h = t.useState([]),
      g = h[0],
      b = h[1],
      f = function f(e) {
    return m(e);
  };

  !function (e, r) {
    t.useEffect(function () {
      var t = function t(_t) {
        var n = null == e ? void 0 : e.current;
        n && !n.contains(_t.target) && r();
      };

      return document.addEventListener("mousedown", t), document.addEventListener("touchstart", t), function () {
        document.removeEventListener("mousedown", t), document.removeEventListener("touchstart", t);
      };
    }, [e, r]);
  }(p, function () {
    m(!1);
  });

  var x = function x(e) {
    return !(null == g || !g.find(function (t) {
      return t.id === e.id;
    }));
  },
      y = {
    alignItems: l ? "flex-start" : "center",
    backgroundColor: "$brand_primary",
    color: "$text_inverse",
    borderLeft: "2px solid $brand_secondary",
    borderTop: "none",
    borderRight: "2px solid $brand_secondary",
    borderBottom: "none",
    "&:hover": {
      backgroundColor: "$brand_primary"
    },
    "& span": {
      width: "14px",
      height: "14px"
    },
    "& div > small": {
      color: "$activeTextSecondary"
    }
  };

  return r.createElement(Ee, {
    ref: p,
    css: {
      "& ul": {
        minWidth: l ? "400px" : "150px"
      }
    }
  }, r.createElement(we, {
    tabIndex: 0,
    role: "button",
    onKeyPress: function onKeyPress() {
      return f(!u);
    },
    onClick: function onClick() {
      return f(!u);
    }
  }, r.createElement("div", null, 0 === (null == g ? void 0 : g.length) ? r.createElement("p", {
    className: "selected-text"
  }, a) : r.createElement(re, null, null == g ? void 0 : g.map(function (e) {
    return r.createElement("p", {
      key: e.id,
      className: "selected-text"
    }, e.title, d && ",");
  }))), r.createElement(n.ChevronDown, {
    color: "#555",
    size: 16
  })), u && r.createElement("ul", null, i.map(function (e) {
    return r.createElement("li", {
      key: e.id,
      className: "select-menu-options"
    }, r.createElement($e, {
      css: x(e) ? v({}, y) : {
        height: l ? "60px" : "24px",
        alignItems: l ? "flex-start" : "center"
      },
      type: "button",
      onClick: function onClick() {
        return function (e) {
          if (g.some(function (t) {
            return t.id === e.id;
          })) {
            var t = g;
            t = t.filter(function (t) {
              return t.id !== e.id;
            }), b([].concat(t)), f(!u);
          } else d ? d && b([].concat(g, [e])) : (b([e]), f(!u));

          c && c(e);
        }(e);
      }
    }, r.createElement("span", null, x(e) && r.createElement(n.Check, null)), r.createElement("div", null, r.createElement("p", null, e.title), l && r.createElement("small", null, e.extra))));
  })));
}, exports.Spacer = ke, exports.Switch = w, exports.Tab = function (e) {
  var t = e.selectedTab,
      n = e.index,
      o = e.handleChange;
  return r.createElement(Fe, {
    role: "presentation"
  }, r.createElement("button", {
    role: "tab",
    id: e.id,
    "aria-selected": t === n,
    "aria-controls": e.tabPanelId,
    tabIndex: t === n ? 0 : -1,
    onClick: function onClick() {
      return o(n);
    },
    ref: e.tabRef
  }, e.title));
}, exports.Tag = ze, exports.Text = Ae, exports.TextArea = Re, exports.ThreePaneWindow = function (e) {
  var t = e.firstPaneChildren,
      n = e.secondPaneChildren,
      o = e.thirdPaneChildren;
  return r.createElement(r.Fragment, null, r.createElement(xe, null), r.createElement(Ne, null, r.createElement(Ie, null, t), r.createElement(Te, null, n), r.createElement(Ve, null, o)));
};